/**
 * @module support/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
export const ADJUST_CHARGES = {
  BUTTON_CANCEL_ID: 'cancel',
  BUTTON_CANCEL_TYPE: 'cancel',
  BUTTON_CANCEL_NAME: 'Send to supervisor',
  BUTTON_CANCEL_CLASS: 'btn btn-secondary m-t-md',
  BUTTON_CANCEL_ACTION: true,
  BUTTON_CANCEL_CHECKAUTHORIZATION: true,
  BUTTON_SUBMIT_ID: 'submit',
  BUTTON_SUBMIT_TYPE: 'submit',
  BUTTON_SUBMIT_NAME: 'Confirm override',
  BUTTON_SUBMIT_DISABLED: true,
  BUTTON_SUBMIT_CLASS: 'btn btn-primary',
  BUTTON_SUBMIT_CHECKAUTHORIZATION: true,
  BUTTON_SUBMIT_ACTION: false,
};
